import * as Yup from 'yup';

export const CandidateSetRatingFormValidationSchema = Yup.object().shape({
  Notes: Yup.string()
    .nullable()
    .max(15000, 'You have exceeded the maximum number of 15000 characters'),
});
